module.exports = __webpack_public_path__ + "static/09-041c081b4d7c4e7ba0abf70fd82a607a.jpeg";